import { DASHBOARD_KEYS } from "../../../../../globalConstants";
import AppWrapper from "../../../../components/cm/AppWrapper";
import CaseListList from "../../../../components/cm/Dashboard/FullPages/CaseList/CaseListList";
import SideBarMain from "../../../../components/cm/SideBarMain";
import { MainNavBarEnum } from "../../../../components/cm/SideBarMain/MainNavBarEnum";
import { useSaveCurrentNavigation } from "../../../../hooks/useSaveCurrentNavigation";

export default () => {
  useSaveCurrentNavigation({ key: DASHBOARD_KEYS.finance });

  return (
    <AppWrapper.WithSidebar sidebar={<SideBarMain activeRoute={MainNavBarEnum.DASHBOARD} />}>
      <CaseListList customBaseDetailPath={"/finance/cases/"} customBaseDetailSegment={"/details"} />
    </AppWrapper.WithSidebar>
  );
};
